import React from 'react';
import '../styles/CompanyInfo.css';

const CompanyInfo = () => {
  return (
    <section className="company-info">
      <div className="info-container">
        <div className="logo-container-info">
          <img 
            src="/assets/images/liugong.png" 
            alt="LiuGong Logo" 
            className="liugong-logo-info"
          />
        </div>
        
        <div className="info-content">
          <div className="info-text">
            <p>
              LiuGong est une marque mondiale reconnue pour ses machines de construction
              robustes, innovantes et adaptées aux environnements les plus exigeants.
            </p>
            
            <p>
              Avec plus de 60 ans d'expertise, LiuGong propose une large gamme d'équipements
              performants : niveleuses, bulldozers, chargeuses, pelles hydrauliques, et bien plus.
            </p>
            
            <p>
              Au Maroc, LGM est le distributeur exclusif de la marque LiuGong, assurant la vente, le
              service après-vente et la disponibilité des pièces de rechange sur tout le territoire.
            </p>
          </div>
          
          <div className="info-stats">
            <div className="info-stat-item">
              <div className="info-stat-icon">
                <img src="/assets/images/workers-icon.png" alt="Workers" />
              </div>
              <div className="info-stat-content">
                <div className="info-stat-number">17 000+</div>
                <div className="info-stat-label">workers</div>
              </div>
            </div>
            
            <div className="info-stat-item">
              <div className="info-stat-icon">
                <img src="/assets/images/engineer-icon.png" alt="Engineers" />
              </div>
              <div className="info-stat-content">
                <div className="info-stat-number">2 000+</div>
                <div className="info-stat-label">R&D ENGINEERS</div>
              </div>
            </div>
            
            <div className="info-stat-item">
              <div className="info-stat-icon">
                <img src="/assets/images/year-icon.png" alt="Experience" />
              </div>
              <div className="info-stat-content">
                <div className="info-stat-number">60+</div>
                <div className="info-stat-label">Years experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyInfo;